import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from "axios";

Vue.config.productionTip = false

window.axios = axios;
window.axios.defaults.headers["X-Auth"] = sessionStorage.getItem("userToken");
window.apiUrl = "https://ssc-2019.now.sh";

new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
